import { listCapitalOneReceiptsByTeamMemberByMatchStatus } from '../../../graphql/custom_queries';
import PropTypes from 'prop-types';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

export const fetchUploadedReceiptsByTeamMemberByStatus = async (props) => {
  try {

    const { status, teamMemberId, limit } = props;

    const gqlParams = {
      teamMemberId: teamMemberId, 
      matchStatus: {eq: status},
      limit: limit || 250,
    };

    console.info('fetchUploadedReceiptsByTeamMemberByStatus GraphQL Params:', gqlParams);

    const response = await client.graphql({
      query: listCapitalOneReceiptsByTeamMemberByMatchStatus,
      variables: gqlParams,
    });

    console.info('fetchUploadedReceiptsByTeamMemberByStatus GraphQL Response:', response);

    // Ensure response is as expected
    if (!response || !response.data || !response.data.capitalOneReceiptsByTeamMemberByMatchStatus) {
      console.warn(`No data returned for status ${status}`);
      return null; // Return null if the response structure is unexpected
    }

    const results = response.data.capitalOneReceiptsByTeamMemberByMatchStatus.items;

    // If results is not an array or is empty, return null
    if (!Array.isArray(results) || results.length === 0) {
      console.warn(`No transactions found for status ${status}`);
      return null;
    }

    return results; // Return the items array if data is present
  } catch (err) {
    console.error('Error in fetchUploadedReceiptsByTeamMemberByStatus:', err);
    return null; // Return null on error
  }
};

fetchUploadedReceiptsByTeamMemberByStatus.propTypes = {
  status: PropTypes.string.isRequired,
  limit: PropTypes.number,
};